/**
 * @desc 下载关单
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.ResponseDto<string>;
export function request(
  params: API.tms.customsClearance.getCustomsDeclarationUrl.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/customsClearance/getCustomsDeclarationUrl`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
